import { Component, Input } from '@angular/core';
import { NgStyle } from '@angular/common';

@Component({
    selector: 'pin-password-info',
    templateUrl: './password-info.component.html',
    styleUrls: ['./password-info.component.scss'],
    imports: [NgStyle]
})
export class PasswordInfoComponent {

  @Input() show;
  @Input() positionLeft;
  @Input() positionTop;
  @Input() customClass = 'password-helper';

}
